import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import JudgeLogin from '../components/auth/JudgeLogin';
import JudgeAccessRequest from '../components/auth/JudgeAccessRequest';

const JudgeLoginView = () => {
  const navigate = useNavigate();
  const { isAuthenticated, role, loading, signOut, authError, clearAuthError } = useAuth();
  const [currentScreen, setCurrentScreen] = useState('login'); // 'login' | 'access-request'
  const [loginError, setLoginError] = useState('');
  const [showErrorFromWrongRole, setShowErrorFromWrongRole] = useState(false);

  useEffect(() => {
    if (!loading && isAuthenticated && role && role !== 'judge') {
      signOut().then(() => {
        setShowErrorFromWrongRole(true);
        setLoginError('Correo o contraseña incorrectos. Intenta de nuevo.');
      });
    }
  }, [isAuthenticated, role, loading, signOut]);

  if (!loading && isAuthenticated && role === 'judge') {
    return <Navigate to="/jueces/dashboard" replace />;
  }

  const handleBackToHome = () => {
    navigate('/');
  };

  const handleGoToAccessRequest = () => {
    setCurrentScreen('access-request');
  };

  const handleBackToLogin = () => {
    setCurrentScreen('login');
  };

  if (currentScreen === 'access-request') {
    return (
      <JudgeAccessRequest
        onBackToHome={handleBackToHome}
        onBackToLogin={handleBackToLogin}
      />
    );
  }

  const forcedError = showErrorFromWrongRole ? loginError : (authError || '');

  return (
    <JudgeLogin
      onBackToHome={handleBackToHome}
      onGoToAccessRequest={handleGoToAccessRequest}
      forcedError={forcedError}
      onErrorDisplayed={() => {
        setShowErrorFromWrongRole(false);
        clearAuthError();
      }}
    />
  );
};

export default JudgeLoginView;
